import useSWR from 'swr';
import apiClient from 'utils/apiClient';

const fetcher = (url) => {
  return apiClient.get(url).then((res) => res.data);
};

export default function useGet(endpoint, options) {
  const key = endpoint || null;
  const { data, error, isLoading, mutate } = useSWR(key, fetcher, options);

  return {
    data,
    error,
    loading: isLoading,
    mutate
  };
}
